const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

/**
 * AI Prompt Query API URL'leri
 */
export const AIPromptQueryUrl = {
    /**
     * AI Prompt listesi getirme (Filtreleme desteği ile)
     * GET /api/v1/aiprompts?category={category}&modelType={modelType}&isActive={isActive}
     */
    GetAIPrompts: Backofficebff + '/v1/aiprompts',

    /**
     * ID'ye göre AI Prompt detayı getirme
     * GET /api/v1/aiprompts/{id}
     */
    GetAIPromptById: Backofficebff + '/v1/aiprompts',

    /**
     * Sistem promptlarını getirme (UI için)
     * GET /api/v1/aiprompts/system-prompts?category={category}&modelType={modelType}
     */
    GetSystemPrompts: Backofficebff + '/v1/aiprompts/system-prompts',

    /**
     * Aktif sistem promptlarını getirme (UI için)
     * GET /api/v1/aiprompts/active-system-prompts?category={category}&modelType={modelType}
     */
    GetActiveSystemPrompts: Backofficebff + '/v1/aiprompts/active-system-prompts',
};

